export const PositionConstants = {
  ADMIN: "Admin",
  SKIPPER: "Skipper",
  OPERATOR: "Operator",
  ROC_RUNNER: "ROC Runner",
  REPLAY_MEDIA: "Replay Media",
  SUPPORT: "Support",
  TD: "TD",
  CAPTAIN: "Captain",
  MARKER: "Marker",
  MOSAIC: "Mosaic",
  ISO: "ISO",
  HFR: "HFR",
  PRE_GAME_CHECKS: "Pre-Game Checks",
  EIC: "EIC",
  SUPERVISOR: "Replay Supervisor",
  SUPERVISOR_ASSIST: "Replay Supervisor Assist",
  PITCH_CLOCK_SUPERVISOR: "Pitch Clock Supervisor B",
};
